import React, { useEffect } from 'react';

const RefundReplacementPolicyPage = () => {
  useEffect(() => {
    document.title = 'Refund and Replacement Policy | SIDEO QR';
  }, []);

  return (
    <main className="min-h-screen bg-slate-50 py-10 px-4 sm:px-6 lg:px-8">
      <article className="max-w-3xl mx-auto bg-white border border-slate-200 rounded-2xl shadow-sm p-6 sm:p-8 lg:p-10">
        <header className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900" style={{ fontFamily: 'Barlow' }}>
            Refund and Replacement Policy
          </h1>
          <p className="text-sm text-slate-500 mt-2">Last Updated: March 24, 2026</p>
        </header>

        <div className="space-y-7 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">1. Introduction</h2>
            <p>
              This policy explains refund and replacement rules for SIDEO QR purchases. It is designed to be strict,
              clear, and fair under applicable Indian consumer law.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">2. Product Nature</h2>
            <p>
              SIDEO QR is a physical QR sticker product with digital activation service. Purchase includes one year of
              service validity from activation. Continued use after one year requires yearly renewal. There is no
              monthly subscription.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">3. No Cancellation Policy</h2>
            <p>
              Orders cannot be cancelled once placed. Please review your details carefully before making payment.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">4. Refund Eligibility</h2>
            <p>Refunds may be considered only in the following cases:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Damaged product delivered.</li>
              <li>Wrong product delivered.</li>
              <li>Product not delivered.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">5. Non-Refundable Cases</h2>
            <p>Refunds are not applicable in the following situations:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>After QR code activation.</li>
              <li>Change of mind after delivery.</li>
              <li>Incorrect usage, mishandling, or damage caused by user action.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">6. Replacement Policy</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Replacement is allowed for damaged or defective items on delivery verification.</li>
              <li>Issues must be reported within 48 hours of delivery.</li>
              <li>Supporting proof (such as clear photos/videos and order details) may be required.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">7. Refund Process</h2>
            <p>
              If approved, refunds are processed to the original payment source within 5–7 working days. Banking or
              payment provider delays beyond this timeline may occur and are outside our direct control.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">8. Contact Support</h2>
            <p>
              For refund or replacement requests, contact <a href="mailto:support@sideo.in" className="text-black hover:underline">support@sideo.in</a> with your order ID,
              delivery details, and supporting evidence.
            </p>
          </section>
        </div>
      </article>
    </main>
  );
};

export default RefundReplacementPolicyPage;
